<div class="matero-error-wrap">
  <div class="matero-error-code">{{code}}</div>
  <div class="matero-error-title" *ngIf="title">{{title}}</div>
  <div class="matero-error-message" *ngIf="message">{{message}}</div>
</div>